import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  class: "parksevice-conatainer"
};
const _hoisted_2 = {
  class: "parkservice-content"
};
const _hoisted_3 = ["innerHTML"];
import { ref, reactive, onMounted, onUnmounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import ScenicList from '@/components/sceniclist/index.vue';
import LowCarbonTab from './components/lowcarbontab/index.vue';
import Footer from '@/components/footer/index.vue';
import DOMPurify from 'dompurify';
import { menus, newsDetail, newsList } from '@/api';
import { processHtmlImages } from '@/utils/images';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const headerbg = require('@/assets/parkbg13f376e.png');
    const tabsWrapRef = ref(null);
    const scenicList = reactive([]);
    const activeIndex = ref(0);
    const serviceList = reactive([]);
    const remark = ref(''); // remark是动态生成的内容

    // PC端鼠标拖动实现
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let navContainer = null;
    const handleMouseDown = e => {
      if (e.button !== 0) return;
      if (!navContainer) {
        navContainer = tabsWrapRef.value?.querySelector('.van-tabs__nav');
      }
      if (!navContainer) return;
      isDragging = true;
      startX = e.pageX - navContainer.offsetLeft;
      scrollLeft = navContainer.scrollLeft;
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    };
    const handleMouseMove = e => {
      if (!isDragging || !navContainer) return;
      e.preventDefault();
      const x = e.pageX - navContainer.offsetLeft;
      const walk = (x - startX) * 1.5;
      navContainer.scrollLeft = scrollLeft - walk;
    };
    const handleMouseUp = () => {
      isDragging = false;
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    onMounted(() => {
      if (tabsWrapRef.value) {
        tabsWrapRef.value.addEventListener('mousedown', handleMouseDown);
      }
      loadCarbonMenus();

      // 检查 state 参数中的 tabId
      if (route.params?.tabId) {
        activeIndex.value = parseInt(route.params?.tabId);
      }
    });
    const loadCarbonMenus = async () => {
      try {
        const {
          data
        } = await menus({
          type: 4
        });
        serviceList.push(...data);
        activeIndex.value = data[0]?.id;
      } catch (error) {}
    };
    onUnmounted(() => {
      if (tabsWrapRef.value) {
        tabsWrapRef.value.removeEventListener('mousedown', handleMouseDown);
      }
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    });
    const handleTabChange = item => {
      // console.log('handleTabChange: ', item)
      remark.value = DOMPurify.sanitize(processHtmlImages(item?.remark));
      loadScenicData(item);
    };
    const loadScenicData = async tabItem => {
      try {
        scenicList.length = 0;
        const {
          data: {
            list,
            count
          }
        } = await newsList({
          mid: tabItem?.id,
          page: 1,
          pageSize: 999
        });
        // 为每条数据添加 tabName 字段
        const dataWithTabName = list.map(item => ({
          ...item,
          tabName: tabItem?.name || ''
        }));
        scenicList.push(...dataWithTabName);
        // console.log('loadScenicData: ', scenicList)
      } catch (error) {
        console.log('loadScenicData error: ', error);
      }
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "news-header",
        style: _normalizeStyle({
          backgroundImage: `url(${_unref(headerbg)})`
        })
      }, [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
        class: "header-title-ch"
      }, "低碳园林", -1), _createElementVNode("div", {
        class: "header-title"
      }, "LOW CARBON", -1)]))], 4), _createElementVNode("div", _hoisted_2, [_createVNode(LowCarbonTab, {
        list: serviceList,
        modelValue: activeIndex.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeIndex.value = $event),
        onChange: handleTabChange
      }, null, 8, ["list", "modelValue"]), !_ctx.$route.params.id ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "content-wrap",
        innerHTML: remark.value
      }, null, 8, _hoisted_3)) : _createCommentVNode("", true), _createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [_ctx.$route.params.id ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: 0
          })) : (_openBlock(), _createBlock(ScenicList, {
            key: 1,
            list: scenicList
          }, null, 8, ["list"]))]),
          _: 2
        }, 1024)]),
        _: 1
      })]), _createVNode(Footer)]);
    };
  }
};